<div class="success-banner" role="status" data-testid="success-banner">
  <span aria-hidden="true">✓</span>
  {{ messageKey() | translate: messageParams() }}
  <ng-content />
</div>
